<template>
	<div v-if="visible" ref="menu" class="overlay-context-menu" :style="{ left: `${x}px`, top: `${y}px` }" @contextmenu.prevent>
		<template v-for="(item, i) in items">
			<div v-if="item.separator" :key="i" class="ocm-separator"></div>
			<div v-else-if="item.swatches" :key="i" class="ocm-swatches">
				<span v-for="c in item.swatches" :key="c" class="ocm-swatch" :class="{ active: c === item.value }" :style="{ background: c }" @click="pick(() => item.onPick(c))"></span>
				<span class="ocm-swatch ocm-swatch-none" title="No color" @click="pick(() => item.onPick(null))">&times;</span>
			</div>
			<div
				v-else
				:key="i"
				class="ocm-item"
				:class="{ disabled: item.disabled, danger: item.danger, 'has-children': item.children }"
				@click="item.children || item.disabled ? null : pick(item.action)"
			>
				<b-icon v-if="item.icon" :icon="item.icon" class="ocm-icon" />
				<span class="ocm-label">{{item.label}}</span>
				<b-icon v-if="item.children" icon="chevron-right" font-scale=".7" />
				<div v-if="item.children" class="ocm-submenu">
					<div
						v-for="(child, j) in item.children"
						:key="j"
						class="ocm-item"
						:class="{ disabled: child.disabled }"
						@click.stop="child.disabled ? null : pick(child.action)"
					>
						<b-icon v-if="child.icon" :icon="child.icon" class="ocm-icon" />
						<span class="ocm-label">{{child.label}}</span>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	data() { return { visible: false, x: 0, y: 0, items: [] }},
	methods: {
		open(event, items) {
			event.preventDefault();
			this.items = items.filter(Boolean);
			this.x = event.clientX;
			this.y = event.clientY;
			this.visible = true;
			this.$nextTick(() => {
				const rect = this.$refs.menu?.getBoundingClientRect();
				if(!rect) return;
				if(rect.right > window.innerWidth) this.x = Math.max(0, window.innerWidth - rect.width - 4);
				if(rect.bottom > window.innerHeight) this.y = Math.max(0, window.innerHeight - rect.height - 4);
			});
			document.addEventListener('mousedown', this.onOutside, true);
			document.addEventListener('keydown', this.onKey, true);
			window.addEventListener('blur', this.close);
		},
		pick(fn) {
			this.close();
			fn && fn();
		},
		onOutside(e) {
			if(!this.$refs.menu?.contains(e.target)) this.close();
		},
		onKey(e) {
			if(e.key === 'Escape') this.close();
		},
		close() {
			this.visible = false;
			document.removeEventListener('mousedown', this.onOutside, true);
			document.removeEventListener('keydown', this.onKey, true);
			window.removeEventListener('blur', this.close);
		},
	},
	beforeDestroy() {
		this.close();
	},
};
</script>

<style lang="scss" scoped>
@import '../../plugins/variable.scss';

.overlay-context-menu {
	position: fixed;
	z-index: 2000;
	min-width: 180px;
	padding: .25rem 0;
	background: $gray-400;
	border: 1px solid $border-color;
	border-radius: .35rem;
	box-shadow: 0 6px 20px rgba(0, 0, 0, .5);
	font-size: .875rem;
	user-select: none;
}

.ocm-item {
	position: relative;
	display: flex;
	align-items: center;
	padding: .3rem .75rem;
	cursor: pointer;
	white-space: nowrap;

	&:hover { background: $gray-600; }
	&.disabled { opacity: .4; cursor: default; &:hover { background: none; } }
	&.danger { color: #ff6b8a; }
	&.has-children:hover > .ocm-submenu { display: block; }
}

.ocm-icon { margin-right: .5rem; }
.ocm-label { flex: 1 1 auto; margin-right: 1rem; }

.ocm-separator {
	height: 1px;
	margin: .25rem 0;
	background: $border-color;
}

.ocm-submenu {
	display: none;
	position: absolute;
	left: 100%;
	top: -.25rem;
	min-width: 180px;
	padding: .25rem 0;
	background: $gray-400;
	border: 1px solid $border-color;
	border-radius: .35rem;
	box-shadow: 0 6px 20px rgba(0, 0, 0, .5);
}

.ocm-swatches {
	display: flex;
	flex-wrap: wrap;
	gap: .35rem;
	padding: .35rem .75rem;
}

.ocm-swatch {
	width: 18px;
	height: 18px;
	border-radius: 50%;
	cursor: pointer;
	border: 2px solid transparent;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
	font-size: .8rem;

	&.active { border-color: #fff; }
	&.ocm-swatch-none { border-color: $border-color; }
}
</style>
